// Configuración de pestañas. Para agregar una lista nueva basta
// con sumar una entrada acá: la UI y el fetch se adaptan solos.
export const TABS = [
  { id: 'alternativa', label: 'Lista de Restaurantes', file: '/data/productos-alternativa.json' },
  { id: 'idg', label: 'Lista IDG - Publico general', file: '/data/productos-idg.json' }
];

export const DEFAULT_TAB = TABS[0].id;
